<template>
  <!-- <value-container v-if="view_only" :value="value" :label="label" :md="md"/>
  <component v-else :is='c_tag' :md3="md==3" :md4="md==4" style="border-bottom: solid 1px lightgrey;padding-bottom:20px">
    <fs1 tag="b">{{label}}</fs1>
    <label :for="`file-upload-st-${id}`" class="custom-file-upload2" style="text-align: right;" :class="dark_t?'dark':''">
      <fs1-span>{{['Cargar', 'Cargando', 'Cargado'][fileStatus]}} </fs1-span>
      <v-icon small>{{['attach_file', 'hourglass_empty', 'check'][fileStatus]}}</v-icon>
      <input :id="`file-upload-st-${id}`" class="btn" type="file" @change="selectFile($event.target.files)">
    </label>
  </component> -->

	<div>
		<b>{{label || ''}}</b>
    <fs1-tooltip text="tipos de archivos  docx, doc, pdf, xlsx, xls, txt.(largo del nombre total debe ser menor a 100 caracteres)"/>
		<br>
		<!-- zona y seleccion de archivo para subir -->
    <label :for="'file-upload-task'+id" v-cloak @drop.prevent="addFile" @dragover.prevent class="zoneDrop" v-if="!disabled && !(!multiple && (imgs.length || loadingFiles.length || item.preview.srcs.length))">
			<h3>
				<v-icon>cloud_upload</v-icon>
				<span> Arrastrar archivo acá o bien, presionar zona para cargar documento</span>
			</h3>
      <input :id="'file-upload-task'+id"
        class="btn"
        multiple
        type="file"
        :accept="f_types.join(', ')"
        @change="selectFile($event.target.files)">
			</label>

    	<!-- imagen que se estan cargando para subir -->
			<div v-for="(fileName, i) in loadingFiles"
				:key="i+'loading'"
				class="imgContainer main-border-color">
				<v-progress-circular style="width: 120px;height:120px"
					:width="3"
					color="#F67B2F"
					indeterminate/>
				<div style="padding:9px;">Cargando {{fileName}}...</div>
			</div>
			<!-- imagen que se cargo y se quiere subir -->
			<div v-for="(src, i) in item.preview.srcs" class="imgContainer main-border-color" :key="i+'prev'">
        <img v-if="f_types_prev_h[item.preview.files[i].type] == 'img'" :src="src"/>
        <h3 style="padding:5px" v-else>
          <v-icon>insert_drive_file</v-icon>
          <span>{{item.preview.files[i].name}}</span>
        </h3>
				<v-btn class="main-color"
					@click="removePreview(i)">
					<v-icon>delete</v-icon>
					<span>Quitar</span>
				</v-btn>
			</div>
		<!-- imagen que ya esta subida -->
		<div v-for="(img, i) in imgs"
			class="imgContainer"
			:key="i+'imgs'">
			<!-- <img :src="img.photo"/> -->
			<img v-if="['jpg','png','jpeg'].includes(get_ext(img[c_key]))" :src="img[c_key]"/>
      <h3 style="padding:5px" v-else :title="img[c_key]">
        <span>{{get_f_name(img[c_key])}}</span>
        <v-icon>insert_drive_file</v-icon>
      </h3>
			<v-btn v-if="!disabled" @click="removePhoto(img)">
				<v-icon>delete</v-icon>
				<span>Quitar</span>
			</v-btn>
			<a v-else :href="img[c_key]" target="_blank">
				<v-btn color="primary">
					<v-icon >insert_drive_file</v-icon>
					<span>Ver</span>
				</v-btn>
			</a>
		</div>
	</div>
</template>
<script>
import {v4 as uuid} from 'uuid';
import inputs from '../mixins/inputs/inputs.js';
export default {
	mixins:[inputs],
  props: ['value','multiple', 'container', 'c_key', 'label', 'disabled','on_remove','on_add'],
  data() {
    return {
      id: uuid(),
      status: 0,

      f_types:[
        'image/jpg',
        'image/png',
        'image/jpeg',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/pdf',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'message/rfc822',
        'text/plain',
        'xls',
        'doc',
      ],
      f_types_prev_h:{
        'image/jpg':'img',
        'image/png':'img',
        'image/jpeg':'img',
      },
      loadingFiles: [],
			preview: { files: [], srcs: []}
    }
  },
  computed:{
    fileStatus() { return this.value ? (typeof this.value === 'string' ? 2 : this.status) : this.status },

		imgs(){
			return this.multiple
				? this.container.filter(m => typeof m[this.c_key] === 'string')
				: (typeof this.container[this.c_key] === 'string' ? [this.container] : []);
		},
		countImgs() { return this.multiple ? this.item.preview.srcs.length + this.item.imgs.length : 1 },
    item() {
			//si es single, el container sera un {}
			//si es multiple ya vendra como []
			const {preview} = this;
			return this.multiple
				? {img: this.container, preview}
				: {img: [this.container], preview};
		},
  },
  methods:{
    get_f_name(str){
      const d = str? str.split('/') : null;
      let l = d? d[d.length-1]: null;
      if (l) {
        l = l.split('.');
        if (l) l.pop();
      }
      return l? l.join(''):'';
    },
    get_ext(str){
      const d = str? str.split('.') : null;
      return d? d[d.length-1]: null
    },
    changeStatus(i){ this.status = i},
    /* selectFile(files) { // files no es un array por lo que sus proto funciones no aplican
      const file = files[0];
      const {changeStatus} = this;
      changeStatus(1);
      this.$emit('update:value', file);
      const reader = new FileReader();
      reader.onload = e => changeStatus(2);
      reader.readAsDataURL(file);
    }, // selectFile */



    addFile(e) {
			let droppedFiles = e.dataTransfer.files;
      			console.log({droppedFiles});
      if(!droppedFiles.length) return;
      //if(this.update) this.update(droppedFiles);
      this.selectFile(droppedFiles);
    },
		selectFile(files) { // files no es un array por lo que sus proto funciones no aplican
		
			const filteredFiles = [];
			for (let f of files) {
        
				if (this.f_types.includes(f.type)) filteredFiles.push(f);
			}
      if(!filteredFiles.length) return;

			this.loadingFiles = [];
			const fs = Object.keys(filteredFiles);
			fs.forEach(i => {
				(function(file, item, loadingFiles, multiple, c_key, on_add) {
						loadingFiles.push(file.name);
						item.preview.files.push(file);
						multiple
							? item.img.push(({}[c_key] = file))
							: item.img[0][c_key] = file;

						const reader = new FileReader();
						reader.onload = e => {
							loadingFiles.splice(
								loadingFiles.indexOf(e.target.name), 1
							);
							item.preview.srcs.push(e.target.result);

							if (on_add) on_add(item.img[item.img.length-1],{preview:item.preview,i:item.preview.srcs.length-1,file});
						};
						reader.readAsDataURL(file);
				})(files[i], this.item, this.loadingFiles, this.multiple, this.c_key, this.on_add);
			});
		},
		removePreview(i) {
			if (this.on_remove) return;//cuando esta ese metodo, las imgs se borran en el metodo removePhoto, ya q las preview son borradas luego de ser guardadas
			this.item.preview.files.splice(i, 1);
			this.item.preview.srcs.splice(i, 1);
		},
		removePhoto(img) {
			if (this.on_remove) this.on_remove(img);
			return this.multiple
				? this.container.splice(this.container.indexOf(img), 1)
				: this.container[this.c_key] = null;
		},
  }
};
</script>

<style scoped>
.zoneDrop {
  text-align: center;
  border:solid 2px grey;
  /* margin: 10px; */
  width: 100%;
  height: 165px;
  padding: 2px;
  display: inline-block;
  border-radius: 12px;
}


.zoneDrop > h3{
  margin-top: 50px;
  display: block;
  height: 103px;
  color: rgb(228, 126, 1);
}
.imgContainer {
  margin: 10px;
  display: inline-block;
  border:solid 1px;
  padding:2px;
  border-radius: 3px;
  text-align: center;
}
.imgContainer img{
  width: 240px;
  height: 120px;
  display:block;
}
.imgContainer button{
  margin: 2px;
}
</style>
